import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

const StepByStep = () => {
    const { t } = useTranslation();
    return (
        <div className='step-by-step-content'>
            <div className='container'>

                <div class="parent">
                    <div class="div1 position-relative">
                        <div className='step-by-step-item-content'>
                            <h3>{t('stepByStep.s1Title')}</h3>
                            <p>{t('stepByStep.s1Text')}</p>
                        </div>
                        <div>
                            <img src="/assets/images/new-img/hizlica-uye-ol.png" alt="" width="100%" />
                        </div>
                        <div className="step-count step-count-1">01</div>
                    </div>
                    <div class="div2 position-relative">
                        <div className='step-by-step-item-content'>
                            <h3>{t('stepByStep.s4Title')}</h3>
                            <p className='mb-0'>
                                <Trans i18nKey="stepByStep.s4Text" components={{ br: <br /> }} />
                            </p>
                        </div>
                        <div>
                            <img src="/assets/images/new-img/kazancinizi-artirin.png" alt="" width="100%" className='step-by-step-item-image2' />
                        </div>
                        <div className="step-count step-count-2">04</div>
                    </div>
                    <div class="div3 position-relative">
                        <div className='step-by-step-item-content'>
                            <h3>
                                <Trans i18nKey="stepByStep.s2Title" />
                            </h3>
                            <p>
                                <Trans i18nKey="stepByStep.s2Text" components={{ br: <br /> }} />
                            </p>
                        </div>
                        <div>
                            <img src="/assets/images/new-img/ozel-referans-kodu.png" alt="" width="100%" className='step-by-step-item-image2' />
                        </div>
                        <div className="step-count step-count-3">02</div>
                    </div>
                    <div class="div4 position-relative">
                        <div className='step-by-step-item-content'>
                            <h3>
                                <Trans i18nKey="stepByStep.s3Title" />
                            </h3>
                            <p>
                                <Trans i18nKey="stepByStep.s3Text" components={{ br: <br /> }} />
                            </p>
                        </div>
                        <div>
                            <img src="/assets/images/new-img/kodunuzu-paylasin.png" alt="" width="100%" className='step-by-step-item-image4' />
                        </div>
                        <div className="step-count step-count-4">03</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StepByStep